import { CommonModule } from '@angular/common';
import { Component, output } from '@angular/core';
import { Icon } from '@millionshow/client-libs';

@Component({
  selector: 'app-swiper-navigation',
  standalone: true,
  imports: [CommonModule, Icon],
  template: `
    <button
      type="button"
      (click)="prev.emit()"
      class="hidden cursor-pointer border border-zinc-200 lg:flex absolute z-10 -left-6 items-center justify-center transition-all -translate-y-1/2 bg-white rounded-full shadow-lg hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed w-12 h-12 top-1/2"
      aria-label="이전 슬라이드">
      <app-icon
        name="material-symbols:arrow-back-ios-rounded"
        class="size-5! text-zinc-500 ml-2" />
    </button>

    <button
      type="button"
      (click)="next.emit()"
      class="hidden cursor-pointer border border-zinc-200 lg:flex absolute z-10 -right-6 items-center justify-center transition-all -translate-y-1/2 bg-white rounded-full shadow-lg hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed w-12 h-12 top-1/2"
      aria-label="다음 슬라이드">
      <app-icon
        name="material-symbols:arrow-forward-ios-rounded"
        class="size-5! text-zinc-500" />
    </button>
  `,
})
export class SwiperNavigationComponent {
  prev = output<void>();
  next = output<void>();
}
